import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { BcAnalytics } from 'common/analytics/analytics.service';

@Component({
  selector: 'app-chat-buttons',
  templateUrl: './chat-buttons.component.html',
  styleUrls: ['./chat-buttons.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ChatButtonsComponent {
  constructor(private _bcAnalytics: BcAnalytics) {
  }

  @Input()
  isEndable: boolean = true;

  @Input()
  isTransferButtonDisabled: boolean = false;

  @Input()
  isDiscussionOpened: boolean;

  @Input()
  hasWrapUps: boolean;

  @Input()
  hasDiscussionsFeature: boolean = false;

  @Input()
  hasBlockChatPermission: boolean = false;

  @Input()
  hasFlagPermission: boolean = false;

  @Input()
  workItemId: string;

  @Input()
  workItemFlaggedState: string | null;

  @Output()
  toggleWrapUpPanel = new EventEmitter<void>();

  @Output()
  openTransferChatSettings = new EventEmitter<void>();

  @Output()
  endChat = new EventEmitter<void>();

  @Output()
  blockChat = new EventEmitter<void>();

  @Output()
  startDiscussion = new EventEmitter<void>();

  public onWrapUpButtonClick(): void {
    this.toggleWrapUpPanel.emit();
    this._bcAnalytics.eventTrack('ChatWrapupButton');
  }

  public onTransferButtonClick(): void {
    this.openTransferChatSettings.emit();
    this._bcAnalytics.eventTrack('ChatTransferButton');
  }

  public onEndChatClick(): void {
    this.endChat.emit();
    this._bcAnalytics.eventTrack('EndChatButton');
  }

  public onDiscussClick(): void {
    this.startDiscussion.emit();
    this._bcAnalytics.eventTrack('DiscussionButton');
  }

  public getChatButtonsClass(): string {
    return this.hasDiscussionsFeature ? 'bc-chat-buttons-flex' : 'bc-chat-buttons-inline';
  }

  public getButtonGroupsClass(): string {
    return this.hasDiscussionsFeature ? 'chat-button-groups' : 'bc-buttons-inline clearfix';
  }

  public onBlockChatClick() {
    this.blockChat.emit();
  }
}
